import React, { useEffect } from "react";
import { Form, Row, Col, Input, Button, Select, Modal } from "antd";
import config from "../../config/form.json";
import { orgmode, showloader, CompanyType } from "../../store/gloabalState";
import { useRecoilValue, useSetRecoilState } from "recoil";
import SectionHeading from "./section-headings";
import useNotify from "../../utils/useNotify";
import Cookies from "js-cookie";
import {
  addUser,
  checkIfFieldExist,
  createOrgSignup,
} from "../../services/httpCalls";
import { onlyNumericDigitsRegex } from "../../config/globalVar";

const BasicInfo = ({ handleChange, orgDetails }) => {
  // initializing form
  const [form] = Form.useForm();

  // getting basic info config
  const configData = config.basicInfo[0];

  // local states

  // global states

  // values
  const mode = useRecoilValue(orgmode);

  // updater/setter
  const setShowLoader = useSetRecoilState(showloader);
  const setCompanyTypes = useSetRecoilState(CompanyType);

  // states

  //constants/binders
  const notify = useNotify();
  const onlyNumericDigitsRegexRef = onlyNumericDigitsRegex;

  const next = async () => {
    handleChange(1);
  };

  // handling duplicate pan number check
  const duplicatePanCheck = async (value) => {
    return checkIfFieldExist("organisation", "PAN", value).then((res) => {
      if (res) {
        return Promise.reject("PAN already exists!");
      }
      return Promise.resolve();
    });
  };

  const validateEmail = async (value) => {
    if (!value) {
      return Promise.reject("Required!");
    }
    if (
      value &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
    ) {
      return Promise.reject("Please enter valid email!");
    }
    if (value && value.length > 50) {
      return Promise.reject("Maximum character limit exceeded!");
    }
    return checkIfFieldExist("user", "EMAIL", value).then((res) => {
      if (res) {
        return Promise.reject("email already exists!");
      }
      return Promise.resolve();
    });
  };

  useEffect(() => {
    if (orgDetails !== null && orgDetails !== undefined) {
      if (Object.keys(orgDetails)?.length > 0) {
        form.setFieldsValue({
          panNumber: orgDetails?.panNumber,
          email: orgDetails?.userList[0]?.email,
          userName: orgDetails?.userList[0]?.name,
          phoneNumber: orgDetails?.userList[0]?.phoneNumber,
          signUpUserRole: orgDetails?.userList[0]?.designation,
          companyType: orgDetails?.companyType,
        });
      }
    } else {
      form.resetFields();
    }
  }, [orgDetails]);

  const handleFinish = async (values) => {
    let validatePanCompanyType_ = validatePanCompanyType();
    if (validatePanCompanyType_ === true) {
      setShowLoader(true);
      let userId = JSON.parse(Cookies.get("userInfo")).id;
      let data_ = {
        panNumber: form.getFieldValue("panNumber"),
        userEmail: form.getFieldValue("email"),
        userName: form.getFieldValue("userName"),
        phoneNumber: form.getFieldValue("phoneNumber"),
        signUpUserRole: form.getFieldValue("signUpUserRole"),
        companyType: form.getFieldValue("companyType"),
        opsUserId: userId,
        accountSubmissionStatus: "PENDING_SUBMISSION_BY_BD_AM",
      };
      await createOrgSignup(data_)
        .then(async (res) => {
          setCompanyTypes(res.companyTypes);
          localStorage.setItem("orgId", res.id);
          localStorage.setItem("CompanyType", res.companyType);
          let data_user = {
            name: form.getFieldValue("userName"),
            email: form.getFieldValue("email"),
            phoneNumber: form.getFieldValue("phoneNumber"),
          };
          await addUser(res.id, data_user).then((resp) => {
            Cookies.set("currentStage", "1");
            Cookies.set("userId", resp.id);
            Cookies.set("pan", form.getFieldValue("panNumber"));
            notify.success("Successfully created organisation!");
            next();
          });
        })
        .catch((err) => {
          notify.error("Not able to create organisation!");
        })
        .finally(() => {
          setShowLoader(false);
        });
    }
  };

  const error = () => {
    Modal.error({
      title: "Please correct PAN Number",
      content:
        "Please select the correct company type or enter the correct PAN number as per your company type. ",
      onOk: () => {},
    });
  };

  const validatePanCompanyType = () => {
    let companyType = form.getFieldValue("companyType");
    let pan = form.getFieldValue("panNumber");
    let panCharAt = pan.charAt(3);
    if (
      companyType === "PRIVATE_LIMITED_COMPANY" ||
      companyType === "PUBLIC_LIMITED_COMPANY" ||
      companyType === "OPC"
    ) {
      if (panCharAt?.toLowerCase() !== "c") {
        error();
      } else {
        return true;
      }
    } else if (companyType === "PARTNERSHIP_FIRM" || companyType === "LLP") {
      if (panCharAt?.toLowerCase() !== "f") {
        error();
      } else {
        return true;
      }
    } else if (
      companyType === "SOLE_PRORIETOR" ||
      companyType === "FREELANCER"
    ) {
      if (panCharAt?.toLowerCase() !== "p") {
        error();
      } else {
        return true;
      }
    }
  };

  const renderField = (field, index) => {
    const { type, label, name, props, style, tooltip } = field;

    // formatting rules
    field?.rules?.forEach((item) => {
      if (item?.pattern) {
        item.pattern = eval(item?.pattern);
      }
      if (item?.required) {
        item.required = eval(item?.required);
      }
      if (item?.validator) {
        item.validator = eval(item?.validator);
      }
    });

    switch (type) {
      case "Form.Item":
        return (
          <React.Fragment>
            <Form.Item
              label={label}
              name={name}
              rules={field?.rules}
              tooltip={tooltip}
              labelCol={field?.labelCol}
              required={eval(field?.required)}
            >
              {field?.children ? renderField(field?.children, 0) : null}
            </Form.Item>
            {field?.subFields
              ? field?.subFields.map((child, childIndex) =>
                  renderField(child, childIndex)
                )
              : null}
          </React.Fragment>
        );
      case "Input":
        return (
          <Input
            disabled={eval(props?.disabled)}
            readOnly={eval(props?.readOnly)}
            name={field?.name}
            onKeyUp={eval(props?.onKeyUp)}
            onBlur={eval(props?.onBlur)}
            type={field?.subType}
          />
        );
      case "Button":
        return (
          <Button
            type={type}
            style={style}
            onClick={eval(props.onClick)}
            disabled={eval(props.disabled)}
          >
            {eval(label)}
          </Button>
        );
      case "Select":
        return (
          <Select
            options={eval(field?.options)}
            readOnly={eval(props?.readOnly)}
            disabled={eval(props?.disabled)}
            showSearch={props?.showSearch}
            allowClear={props?.allowClear}
            default={field?.default}
            filterOption={eval(props?.filterOption)}
            onKeyUp={eval(props?.onKeyUp)}
            optionFilterProp={props?.optionFilterProp}
            placeholder={field?.placeholder}
          />
        );
      case "SectionHeading":
        return (
          <SectionHeading
            style={field?.style}
            level={field?.level}
            heading={field?.heading}
            Col={field?.Col}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Form
      {...configData.formConfig}
      form={form}
      onFinish={handleFinish}
      disabled={mode === "view"}
    >
      <Row gutter={[16, 16]}>
        {configData.fields.map((field, index) => {
          // conditional render
          const shouldRender = true;

          return (
            shouldRender && (
              <Col key={index} span={field?.Col ? field.Col : 12}>
                {renderField(field, index)}
              </Col>
            )
          );
        })}
      </Row>
      <div className="fixed_btn_wrap">
        <Button
          type="primary"
          style={{ marginLeft: ".5rem" }}
          htmlType="submit"
        >
          Next
        </Button>
      </div>
    </Form>
  );
};

export default BasicInfo;
